"use client";
import dynamic from "next/dynamic";

export const BuilderCreditCardLandingAnimation = dynamic(
  () => import("components/parts/BuilderIO/BuilderCreditCardLandingAnimation"),
  { ssr: false }
);
